<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(2.690608, 0, 0, 2.414501, -1929.610718, -1913.392822)">
    <path
      d="M757.859,883.623h-31.521c-3.31,0-5.995,2.685-5.995,5.996v100.385c0,3.312,2.685,5.996,5.995,5.996h25.424 c3.259,0,5.921-2.604,5.995-5.863l0.102-4.605V883.623L757.859,883.623z"
    />
    <path
      d="M874.249,868.261c-15.132,0-40.775,0-40.775,0s1.458-7.302,5.521-39.328C842.448,801.717,823.446,796,811.168,796 l-41.794,99.999v87.216l21.422,5.784c9.838,2.656,19.988,4.004,30.179,4.004h29.067c11.352,0,21.403-7.374,24.826-18.197 c9.536-30.143,19.473-61.532,23.368-73.899C904.884,879.802,889.386,868.261,874.249,868.261z"
    />
  </g>
</template>
